import axiosPrivate from "@services/axiosPrivate"
import { ADD_READING } from "src/constants"

export const addReading = (data) => {
    return axiosPrivate.post(ADD_READING, data, {
        withCredentials: true,
    })
}
